import Vue from 'vue';

//Fundraisers

export const PageHeader = Vue.component('page-header', require('./components/PageHeader.vue'));


// WEBPACK FOOTER //
// ./resources/js/views/layouts/index.js